import { ChangeHistory, nativeHandler, getAppInfo, getURLParameter } from 'utils';
import { getTransactionDetail, getTransactionFulfillDetail } from '../Services';
import Rupay from 'assets/card-issuer/rupay.png';
import MasterCard from 'assets/card-issuer/master-card.png';
import Amex from 'assets/card-issuer/amex.png';
import Visa from 'assets/card-issuer/visa.png';
import Diner from 'assets/card-issuer/diners.svg';
import { toast } from 'react-toastify';
import store from 'redux/store';
import globalConstant from 'constants/globalConstant';

export const CARD_SOURCE = {
	BUREAU: 'BUREAU',
	USER: 'USER',
	USER_ADDED: 'USER_ADDED',
	BUREAU_PULLED: 'BUREAU_PULLED',
};

export const PAYMENT_MODES = {
	SEND_MONEY: 'SEND MONEY',
	POSTPE: 'POSTPE',
	PG: 'PG',
};

export const CARD_CATEGORY = {
	DINER: 'DINER',
	AMEX: 'AMEX',
	OTHER: 'OTHER',
};

export const PUBLIC_KEY =
	'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA9hsLwZF/HUk/IDxFZgK0DszZi1Cl25qAfEnfDSj7B4uYGvOr4ZSJULzhG7s0k3SyMILWSffm/O7WhfqE2s6At1ZKM/DlOwk9PO4iEgIOHh3uKf1k+LpnJLQpS3t3Bt2c5hftRthQx0C/kx+ysTQ6ngtaZM3LyrfD41JqDuMhe/dOuMGYSdUbm4zyPPXGqV5fjqvYAKx0dET+7meDJfG8t+PptJlDW85DdD0s8RCCN/NQ4zio4nbsRccZ9Lp6r3oM4wtytn5wjM6nsW4kzq0+djlvAB6OH6PzI0Q2l1zWlCrYDx1wROhYwtNCs/xe10Ua0xfzp5LcEYcjWAwG/XwrmwIDAQAB'; //prod key
// 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAn2R4L9iahXMbnNea6XmKTmqxkEFeqkk1xmEeSvEPJjOw0mBu/qtTMEknSTxhNO/StlRhuK/SFzhKDEAwBhxQVSUGEBtbldR2OPy4uHj0Vx2Fokl20VfYjJvnzt58sFmfCM0Xpec8gXb2n756sF0UTUV5jazgbEg8iZ5SpJI+EXd0lTO+7AbLcqm9eXZLN6T1VNeoIjOFltQ6x/ue6z5yo4xySpP8dN3MNU/gU+F0hcEuTLM1EovgjaxmREuWluu0cP07e3qpU/3joChe1L7FthxwjTZmKvBjPFW02WSsl3cXpBgc/WvdpMyB7brgPafrBpWy+qQhsxKdmHq+JIa2qwIDAQAB'; //stage key

export const TRANSACTTION_STATUS = {
	SUCCESS: 'Transaction Successful',
	PENDING: 'Transaction Pending',
	FAILED: 'Transaction Failed',
	CANCELLED: 'Transaction Cancelled',
};

export const VAS_TRANSACTION_STATUS = {
	PENDING: 'PENDING',
	SUCCESS: 'SUCCESS',
	PENDING_CANCELLATION: 'PENDING_CANCELLATION',
	CANCELLED: 'CANCELLED',
	PAYMENT_FAILED: 'PAYMENT_FAILED',
	FAILED: 'FAILED',
	REFUND_PENDING: 'REFUND_PENDING',
	REFUND_SUCCESS: 'REFUND_SUCCESS',
	REFUND_FAILED: 'REFUND_FAILED',
};

export const PUBLIC_KEY_JUSPAY =
	'-----BEGIN CERTIFICATE-----\n' +
	'MIIGnzCCBYegAwIBAgIIV7ftaT9OnxQwDQYJKoZIhvcNAQELBQAwgbQxCzAJBgNV\n' +
	'BAYTAlVTMRAwDgYDVQQIEwdBcml6b25hMRMwEQYDVQQHEwpTY290dHNkYWxlMRow\n' +
	'GAYDVQQKExFHb0RhZGR5LmNvbSwgSW5jLjEtMCsGA1UECxMkaHR0cDovL2NlcnRz\n' +
	'LmdvZGFkZHkuY29tL3JlcG9zaXRvcnkvMTMwMQYDVQQDEypHbyBEYWRkeSBTZWN1\n' +
	'cmUgQ2VydGlmaWNhdGUgQXV0aG9yaXR5IC0gRzIwHhcNMjIwNTExMDgzMTUzWhcN\n' +
	'MjMwNTExMDgzMTUzWjAdMRswGQYDVQQDExJtb3JwaGV1cy5qdXNwYXkuaW4wggEi\n' +
	'MA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQC4oYr5h3iY83kWi7Jy6Eq0unL8\n' +
	'W+oienrAx9poeXByUynh61LHoD9qeH/WxmgoFdbzKzJdoZ6lMMA+ovY+x9DvNpom\n' +
	'A8FCkp9QrnW3yXB6irqRIdn+j1bcGQ/J7aIAWfncUOpJkaZXczw/LLtWuNn4fgEj\n' +
	'ka0A0F3sy4eZCApPT8gw9DgqG2m1xZM/5w5EwAqw4pVRNnHnJd+NqemSK/LgfTIW\n' +
	'1a6g4mBHPG7g/v8vQS8H8+674H2eCibfxoHxU3T5d9/5FKjjPPrCfYjE+b5e5Rta\n' +
	'M7qnxrUfA2PfjxeVTo1+kIMNw9hkX4JqbgpkPpyRTwkLl9HHqJLW325SewGzAgMB\n' +
	'AAGjggNJMIIDRTAMBgNVHRMBAf8EAjAAMB0GA1UdJQQWMBQGCCsGAQUFBwMBBggr\n' +
	'BgEFBQcDAjAOBgNVHQ8BAf8EBAMCBaAwOAYDVR0fBDEwLzAtoCugKYYnaHR0cDov\n' +
	'L2NybC5nb2RhZGR5LmNvbS9nZGlnMnMxLTQwOTMuY3JsMF0GA1UdIARWMFQwSAYL\n' +
	'YIZIAYb9bQEHFwEwOTA3BggrBgEFBQcCARYraHR0cDovL2NlcnRpZmljYXRlcy5n\n' +
	'b2RhZGR5LmNvbS9yZXBvc2l0b3J5LzAIBgZngQwBAgEwdgYIKwYBBQUHAQEEajBo\n' +
	'MCQGCCsGAQUFBzABhhhodHRwOi8vb2NzcC5nb2RhZGR5LmNvbS8wQAYIKwYBBQUH\n' +
	'MAKGNGh0dHA6Ly9jZXJ0aWZpY2F0ZXMuZ29kYWRkeS5jb20vcmVwb3NpdG9yeS9n\n' +
	'ZGlnMi5jcnQwHwYDVR0jBBgwFoAUQMK9J47MNIMwojPX+2yz8LQsgM4wNQYDVR0R\n' +
	'BC4wLIISbW9ycGhldXMuanVzcGF5LmlughZ3d3cubW9ycGhldXMuanVzcGF5Lmlu\n' +
	'MB0GA1UdDgQWBBTPkfTsRrRzFIzAnUX0MBuTJfUGGjCCAXwGCisGAQQB1nkCBAIE\n' +
	'ggFsBIIBaAFmAHUA6D7Q2j71BjUy51covIlryQPTy9ERa+zraeF3fW0GvW4AAAGA\n' +
	'sj795AAABAMARjBEAiAi5GKXMwMipMO9HuXYY7iONGeOStqIFWKB3MXJmi6ykgIg\n' +
	'diqhrX7KTLWLWcHXFFIfffK/r6AXd7zbZqdq/YLsqowAdQA1zxkbv7FsV78PrUxt\n' +
	'Qsu7ticgJlHqP+Eq76gDwzvWTAAAAYCyPv7JAAAEAwBGMEQCIEeSmdVjzbUrVSTz\n' +
	'Dd3rREk4z4vyyAGddgG5hp6og+WxAiBFY/jvi7ILYpikdPr2DyPsMGrA7luBMT3J\n' +
	'NWfKYj6r8gB2AHoyjFTYty22IOo44FIe6YQWcDIThU070ivBOlejUutSAAABgLI+\n' +
	'/1MAAAQDAEcwRQIhAO99nxOYcf2oeVXU1QDwYXqsnAKXpXay29QWB0BqUSD0AiAG\n' +
	'SXADzBWQu8ksxkvVlLTma0GUvu8rplhaQ2j2ujZJqTANBgkqhkiG9w0BAQsFAAOC\n' +
	'AQEAL1Xq+4O12dw8G0NASrGi7YtqopGcqsV4WmwlrBKmZtoyE94NHJ8v5JNpOKXV\n' +
	'hIoFKivrOD5bjyaz90ArwnR/Pd4u0SzLT39j9vq0blQl/58gnqxL6OWfKexGnzXF\n' +
	'jlJnpeDvpxhzcNPXicx+66dHuDwPz7EiqiAHlCRo8upwFo3PxezxzvMDD5mm/DsH\n' +
	'5RKcobKEbOZCo3VJMkQPn0hku3M4FBbVT1G7nAoCWJiaJX2ZYKrCEcX9OSwTfeUL\n' +
	'xM67VufFibskA+EPE+mT1SewkXpiT8JiuuVtSGNc0nMBMzbs/Z7dBWAUNhozFlym\n' +
	'ujxfrDWrY7BhbxD4diAsvELZ8Q==\n' +
	'-----END CERTIFICATE-----';

// '-----BEGIN CERTIFICATE-----\n' +
// 'MIIDTDCCAjQCCQCRMOiPJQzheDANBgkqhkiG9w0BAQsFADBoMQswCQYDVQQGEwJJ\n' +
// 'TjESMBAGA1UECAwJS2FybmF0YWthMRIwEAYDVQQHDAlCYW5nYWxvcmUxDzANBgNV\n' +
// 'BAoMBkp1c3BheTEPMA0GA1UECwwGUGF5b3V0MQ8wDQYDVQQDDAZqdXNwYXkwHhcN\n' +
// 'MjIwNDA0MTIyNzM2WhcNMjMwNDA0MTIyNzM2WjBoMQswCQYDVQQGEwJJTjESMBAG\n' +
// 'A1UECAwJS2FybmF0YWthMRIwEAYDVQQHDAlCYW5nYWxvcmUxDzANBgNVBAoMBkp1\n' +
// 'c3BheTEPMA0GA1UECwwGUGF5b3V0MQ8wDQYDVQQDDAZqdXNwYXkwggEiMA0GCSqG\n' +
// 'SIb3DQEBAQUAA4IBDwAwggEKAoIBAQCo5wTbiPxuOXBXbMsaFGrQ+mg8IUFekMFN\n' +
// 'A7qyG9WAESgOUDtknmUQdkL+Ixk96BTtY4M5ZJ76pq0gvFzB30y0TM0YyU7tNbez\n' +
// 'B2/5F5QqMJnhBgc0SKgspkSY7E3kRAEuVgY+cdCsSDijnGeoppkOtUXcqs6hmSbw\n' +
// 'I5bomkLFch08F/PPi9lKK4TpCiXninseAf4ju11+9zSkIr2Sa1/TG7Bz9BwJ90jI\n' +
// 'ecQN/PepST926qFGVe0tTbrKyqq91g/qRJIyG/zAJzNiACs//dC8sFPE1ZPMM60I\n' +
// 'LLZyuoKlJEwdU7m4QVC2/8uuYHkY/XzGOKCirEmFilYuXpOCSdlxAgMBAAEwDQYJ\n' +
// 'KoZIhvcNAQELBQADggEBAGxTKJg9Y5G9jhLMDon7vZWjqZK7FB1nx8gJiD8pyqui\n' +
// 'Q3Ta8omrITk2kHm57SfgHpdD42NPubiL8IVREd8g65LuUN0X1ga4yfBIgzMp2OzD\n' +
// 'PHbmNxqSd7ANBuPP3h778Ept+B56FHdOU0eELh2z46zs5m6BvEQMDohweHyHUFeq\n' +
// 'F+nFhg9xk8ZC2XSaLxZgFFW3gpLNS1H2EnKP1/kKIGafUmVwJLjIEVD09fovaZXQ\n' +
// 'zwu79UnIhA9mO4l6zSNQdXh5yJa3bm+P1gyJRmTZeKgBnSn5DvOOf1+VF3YCOuPD\n' +
// 'Isj5DK6b9v5OuxjQ7Zla7cGNZX5EMIYsjxCKMLCm/JY=\n' +
// '-----END CERTIFICATE-----';

export const triggerCcPaymentDetailApi = async ({ orderId }) => {
	try {
		await getTransactionFulfillDetail({ sourceRefId: orderId });
	} catch (e) {
		toast.error(e.error.message);
	}
	await orderDetails(orderId);
};

export const orderDetails = async (orderId) => {
	try {
		const data = await getTransactionDetail({ sourceRefId: orderId });
		if (data) {
			ChangeHistory('push', '/credit-card-txnDetail', {
				...data,
				path: !!getURLParameter(globalConstant.URL_PARAMETER.SOURCE) ? '' : 'pg-return',
				checkRewards: true,
			});
			nativeHandler.removeLoader();
		} else {
			ChangeHistory('push', `/${getPrimaryRoute(store?.getState()?.homeDetails?.accountType)}/home`);
		}
	} catch (e) {
		toast.log(e);
	}
};

export const getPrimaryRoute = (accountType) => {
	let primaryRoute = '';
	switch (accountType) {
		case 'PREPAID':
			primaryRoute = 'prepaid';
			break;

		case 'POSTPAID':
			primaryRoute = 'postpaid';
			break;

		case 'RECEIVED_LIMIT':
			primaryRoute = 'received-limit';
			break;

		default:
			break;
	}
	return primaryRoute;
};

export const validateCCbyLuhn = (value) => {
	//Luhn Algorithm Check
	if (/[^0-9-\s]+/.test(value)) return false;
	let nCheck = 0,
		bEven = false;
	value = value.replace(/\D/g, '');

	for (var n = value.length - 1; n >= 0; n--) {
		var cDigit = value.charAt(n),
			nDigit = parseInt(cDigit, 10);

		if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

		nCheck += nDigit;
		bEven = !bEven;
	}

	return nCheck % 10 == 0;
};

export const getCardIssuerLogo = (cardNumber) => {
	if (cardNumber[0] === '4') return Visa;
	else if (
		['60', '65', '81', '82'].includes(cardNumber.substring(0, 2)) ||
		['508', '353', '356'].includes(cardNumber.substring(0, 3))
	)
		return Rupay;
	else if (
		(+cardNumber.substring(0, 2) >= 51 && +cardNumber.substring(0, 2) <= 55) ||
		(+cardNumber.substring(0, 4) >= 2221 && +cardNumber.substring(0, 4) <= 2720)
	)
		return MasterCard;
	else if (['34', '37'].includes(cardNumber.substring(0, 2))) return Amex;
	else if (['36'].includes(cardNumber.substring(0, 2))) return Diner;
};

export const isAmexCard = (cardNumber) => {
	return ['34', '37'].includes(cardNumber.substring(0, 2));
};
export const isDinerCard = (cardNumber) => {
	return ['36'].includes(cardNumber.substring(0, 2));
};

export const getCardCategory = (cardLength) => {
	if (cardLength === 15) return CARD_CATEGORY.AMEX;
	if (cardLength === 14) return CARD_CATEGORY.DINER;
	return CARD_CATEGORY.OTHER;
};
export const getCardNumber = (cardCategory) => {
	if (cardCategory === CARD_CATEGORY.DINER) return 14;
	if (cardCategory === CARD_CATEGORY.AMEX) return 15;
	return 16;
};
